import { jsx as _jsx } from "react/jsx-runtime";
export function ColumnWrapper(props) {
    const { stopPropagation = true, children, ...otherProps } = props;
    return (_jsx("div", { ...otherProps, onClick: (e) => {
            if (stopPropagation)
                e.stopPropagation();
        }, children: children }));
}
